import { render, staticRenderFns } from "./CommonTabs.vue?vue&type=template&id=6bd35092&scoped=true"
import script from "./CommonTabs.vue?vue&type=script&lang=js"
export * from "./CommonTabs.vue?vue&type=script&lang=js"
import style0 from "./CommonTabs.vue?vue&type=style&index=0&id=6bd35092&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd35092",
  null
  
)

export default component.exports